export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `<p>Яркая и насыщенная печать с обеих сторон чехла. Принт не чувствуется на ощупь и не стирается. По длинной стороне чехла располагается аккуратная молния.Чехол гладкий снаружи и плотный внутри, а толщина ткани обеспечит надежную защиту от ударов.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.</p>
        <p>Можно стирать в машинке.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
